export const COLLECTION_URL =
  "https://www.motousher.com/collections/own-your-adventure";

export const IMAGES = {
  heroMoto:
    "https://static.prod-images.emergentagent.com/jobs/921aceaf-e85c-49f2-8956-3b750efc917e/images/06ff973f1347ccd02522e801cdf6db42b120b3c985c117163e4813cab56e704a.jpeg",
  rider:
    "https://static.prod-images.emergentagent.com/jobs/921aceaf-e85c-49f2-8956-3b750efc917e/images/0c021e751294c84559b0880d0c868aed7571b2857dc8167f7c630da4f5065480.jpeg",
  sliders:
    "https://static.prod-images.emergentagent.com/jobs/921aceaf-e85c-49f2-8956-3b750efc917e/images/36b4e5246cfbc0d3d6f3cde1e58f7d79fd78ddfbaffae936774f13cdd77ea266.jpeg",
  auxLights:
    "https://static.prod-images.emergentagent.com/jobs/921aceaf-e85c-49f2-8956-3b750efc917e/images/85262c7c2efe817502b8bb1e9b58f68c8313aa050ab777c524ed8ff161a3ad34.jpeg",
  chain:
    "https://images.unsplash.com/photo-1731694405804-a1f752925420?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxtb3RvcmN5Y2xlJTIwY2hhaW4lMjB0b29sJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3ODY4NzI0NzN8MA&ixlib=rb-4.1.0&q=85",
  valve:
    "https://images.unsplash.com/photo-1719929830722-1d173b29b72e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxtb3RvcmN5Y2xlJTIwdGlyZSUyMHZhbHZlJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3ODY4NzI0ODd8MA&ixlib=rb-4.1.0&q=85",
};

export const PRODUCTS = [
  {
    id: "ergonomics",
    n: "01",
    title: "Ergonomics",
    desc: "Mirror height adaptors, width extenders & cushion grips.",
    img: IMAGES.rider,
    span: "md:col-span-2 md:row-span-2",
    tall: true,
  },
  {
    id: "utility",
    n: "02",
    title: "Utility Tools",
    desc: "Hex axle, tyre levers & spindle tools.",
    img: IMAGES.sliders,
    span: "",
  },
  {
    id: "aux",
    n: "03",
    title: "AUX Light Clamps",
    desc: "Bar & fork mounts for Baja-grade lighting.",
    img: IMAGES.auxLights,
    span: "",
  },
  {
    id: "chain",
    n: "04",
    title: "Chain Care Tools",
    desc: "Grunge brushes & lube holders.",
    img: IMAGES.chain,
    span: "",
  },
  {
    id: "valves",
    n: "05",
    title: "Tyre Valves & Stems",
    desc: "90° aluminium & brass valves.",
    img: IMAGES.valve,
    span: "",
  },
];

export const CHIPS = [
  "Mirror Adaptors",
  "Width Extenders",
  "AUX Light Clamps",
  "Fork Sleeves",
  "Screen Protectors",
  "Chain Tools",
  "Wiring Harness",
  "Tyre Valves",
];

export const TRUST = [
  {
    n: "01",
    title: "Built on Trust",
    metric: "300+ retailers · 2K+ riders",
    desc: "A network forged over years of dependable supply and real support.",
  },
  {
    n: "02",
    title: "Dispatched with Speed",
    metric: "Same-day in-stock shipping",
    desc: "Order by 2:00 pm and in-stock parts leave the shelf the same day.",
  },
  {
    n: "03",
    title: "Expert Support",
    metric: "Direct manufacturer access",
    desc: "Talk to the people who source and make the parts — not a script.",
  },
  {
    n: "04",
    title: "Driven by Value",
    metric: "Source-country pricing",
    desc: "Fair, consistent pricing over gimmicks and inflated marketing.",
  },
];
